// src/firebase.js

import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAbT8ac7nAyTD8Jd-yZFGiqpTxApEQJ0eo",
  authDomain: "promo-grind.firebaseapp.com",
  projectId: "promo-grind",
  storageBucket: "promogrind.firebasestorage.app",
  messagingSenderId: "732351511279",
  appId: "1:732351511279:web:825a3ae17d024be15e791a",
  measurementId: "G-0BQ645TFEZ"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const storage = getStorage(app);

const shouldUseEmulators =
  process.env.NODE_ENV !== 'production' &&
  process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true';

if (shouldUseEmulators && typeof window !== 'undefined') {
  const emulatorState = window.__PROMOGRIND_FIREBASE_EMULATORS__ || {};

  if (!emulatorState.auth) {
    connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
    emulatorState.auth = true;
  }

  if (!emulatorState.firestore) {
    connectFirestoreEmulator(db, '127.0.0.1', 8081);
    emulatorState.firestore = true;
  }

  if (!emulatorState.functions) {
    connectFunctionsEmulator(functions, '127.0.0.1', 5001);
    emulatorState.functions = true;
  }

  window.__PROMOGRIND_FIREBASE_EMULATORS__ = emulatorState;
}

export { auth, db, functions, storage };
